export default "__VITE_ASSET__7SL0euaB__"